export const textConverter = (text: string): string => {
  return (text || '').replaceAll(/\r\n/g, '\n');
};
